<template>
  <mt-popup v-model="currentValue" position="bottom">
    <mt-picker ref="picker" class="picker" :slots="buildItems" valueKey="name" showToolbar :itemHeight="44">
      <div class="toolbar">
        <button class="toolbar-item cancel-item" @click="cancel">{{ $t('MessageBox.Cancel') }}</button>
        <div class="picker-header">{{ $t('Please select a region') }}</div>
        <button class="toolbar-item confirm-item" @click="confirm">{{ $t('MessageBox.Confirm') }}</button>
      </div>
    </mt-picker>
  </mt-popup>
</template>

<script>
import { getArea } from '../api/area'
export default {
  name: 'RegionPicker',
  data() {
    return {
      currentValue: false,
      countries: [
        { name: '', area_id: 1, code: '' }
      ]
    };
  },
  created: function () {
    getArea().then(res => {
      this.countries = res.result.area_list
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {
    buildItems() {
      return [{
        flex: 1,
        values: this.countries,
        textAlign: 'center'
      }];
    }
  },
  methods: {
    cancel() {
      this.currentValue = false;
    },
    confirm() {
      this.currentValue = false;
      const selectedCountry = this.$refs.picker.getValues();
      this.$emit('onConfirm', selectedCountry);
    }
  }
}
</script>

<style lang="scss" scoped>
.picker {
  background-color: #ffffff;
}

.toolbar {
  height: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background-color: #f0f2f5;
}

.mint-popup-bottom {
  width: 100%;
  height: 13.8rem;
  border: 0;
  overflow: auto;
}

.toolbar-item {
  font-size: $h2;
  border: none;
  background-color: #f0f2f5;
}

.cancel-item {
  margin-left: 0.4rem;
  color: #333;
}

.confirm-item {
  margin-right: 0.4rem;
  color: red;
}

.picker-header {
  color: #333;
  line-height: 2rem;
}
</style>